import { cn } from '@/util/cn'
import { ReactNode } from 'react'

type Props = { className?: string }
export const Divider = ({ className }: Props) => (
    <div className={cn(`divider divider-primary mb-2 opacity-50`, className)} />
)
export const VerticalDivider = ({ className }: Props) => (
    <div className={cn(`divider divider-horizontal divider-primary opacity-50`, className)} />
)

export const Pill = ({ className, children }: Props & { children: ReactNode }) => (
    <div
        className={`text-base-content shadow-primary inline-block px-1 py-2 font-semibold drop-shadow-lg md:text-lg ${className}`}
    >
        {children}
    </div>
)
